import EditClient from './EditClient';
export default EditClient;
